import {Component, Injector} from "@angular/core";
import {
    AbstractSelectSearchControlComponent
} from "../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {registerSearchControl} from "../../framework/entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-bi-top-bottom-count-single-select-search-control",
    templateUrl: "../../framework/entity/search/search-controls/select-search-controls/single-select-search-control.component.html",
    providers: [
        registerSearchControl(TopBottomCountSingleSelectSearchControlComponent)
    ]
})
export class TopBottomCountSingleSelectSearchControlComponent extends AbstractSelectSearchControlComponent<any> {
    constructor(injector: Injector) {
        super(undefined, injector);

        this.buildData([
            {label: "wbo.bi.search.option.top-bottom-count.top5", value: "top5"},
            {label: "wbo.bi.search.option.top-bottom-count.top10", value: "top10"},
            {label: "wbo.bi.search.option.top-bottom-count.top25", value: "top25"},
            {label: "wbo.bi.search.option.top-bottom-count.top50", value: "top50"},
            {label: "wbo.bi.search.option.top-bottom-count.bottom5", value: "bottom5"},
            {label: "wbo.bi.search.option.top-bottom-count.bottom10", value: "bottom10"},
            {label: "wbo.bi.search.option.top-bottom-count.bottom25", value: "bottom25"},
            {label: "wbo.bi.search.option.top-bottom-count.bottom50", value: "bottom50"}
        ]);
    }
}
